import { Box, BoxProps, IconButton, SxProps, Theme, Typography, useTheme } from '@mui/material';
import { X } from 'lucide-react';
import React from 'react';
import { FormattedMessage } from 'react-intl';

type Props = BoxProps & {
  dark?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  text?: string;
  sx?: SxProps<Theme> | undefined;
};
const ClearSelection: React.FC<Props> = ({ dark = false, onClick, text, sx }) => {
  const theme = useTheme();
  const color = dark ? theme.palette.darkBlue.main : theme.palette.common.white;

  return (
    <Box
      sx={{
        position: 'relative',
        alignItems: 'center',
        display: 'flex',
        ...sx,
      }}>
      <IconButton
        sx={{
          display: 'flex',
          gap: 2,
        }}
        onClick={onClick}
        disableRipple>
        <Typography color={color}>{text ?? <FormattedMessage id={`general.clearSelection`} />}</Typography>
        <X size={24} color={color} />
      </IconButton>
    </Box>
  );
};

export default React.memo(ClearSelection);
